export const CHART_COLORS = [
  '#2563B0', '#0F7A5A', '#C2410C', '#7C3AED', '#D97706',
  '#0891B2', '#BE185D', '#4D7C0F', '#9D174D', '#1D4ED8',
  '#059669', '#DC2626', '#7C3AED', '#F59E0B', '#06B6D4',
  '#8B5CF6', '#EC4899', '#14B8A6', '#F97316', '#6366F1'
];

export function generateColors(count) {
  const result = [];
  for (let i = 0; i < count; i++) {
    result.push(CHART_COLORS[i % CHART_COLORS.length]);
  }
  return result;
}
